import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { useAuthStore } from "@/store/auth-store";
import type { ApiHoliday, PaginatedResponse } from "@/types/api";

/**
 * Fetch the public-holiday calendar for ``country`` (ISO-2 code, default
 * Colombia). The backend serves the current year + next year so the
 * "upcoming holidays" panel never runs out near year-end. The custom Ninja
 * ``Router`` in this codebase wraps every list response in a paginated
 * envelope, so we unwrap ``.items`` here.
 */
export function useHolidays(country = "CO") {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const organizationId = useAuthStore((s) => s.organizationId);

  return useQuery({
    queryKey: ["holidays", country],
    queryFn: async () => {
      const params = new URLSearchParams({ country });
      const res = await api.get(`holidays/?${params}`).json<PaginatedResponse<ApiHoliday>>();
      return res.items;
    },
    enabled: isAuthenticated && !!organizationId,
    staleTime: 1000 * 60 * 60 * 24, // refetch at most once a day
  });
}
